<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>

    <form
      class="w-100"
      style="margin-top: 82px; padding: 24px"
      @submit.prevent="editUser"
    >
      <Breadcrumb :items="breadcrumbItems" />

      <section
        style="margin-top: 32px"
        class="d-flex flex-column justify-content-between align-items-center w-100"
      >
        <div class="d-flex w-100 session-one">
          <section
            class="card-styling d-flex flex-column justify-content-between align-items-start"
            id="section-personal-data"
          >
            <h6 style="margin-bottom: 32px">Dados Pessoais</h6>

            <div class="d-flex w-100" style="height: -webkit-fill-available">
              <div
                class="d-flex flex-column align-items-center justify-content-between w-100"
              >
                <img
                  :src="require('@/assets/images/svg/avatar-default.svg')"
                  alt="Anexar uma imagem perfil"
                  style="margin-bottom: 16px"
                />
                <!-- <img
                  v-if="url"
                  width="101"
                  height="100"
                  :src="url"
                  alt="Anexar uma imagem perfil"
                  style="margin-bottom: 16px"
                />
                <img
                  v-else
                  :src="require('@/assets/images/svg/user-default-image.svg')"
                  alt="Anexar uma imagem perfil"
                  style="margin-bottom: 16px"
                />
                <label id="label-attach-image" for="attach-image"
                  >Alterar Foto</label
                >
                <input
                  accept="image/*"
                  id="attach-image"
                  type="file"
                  @change="onFileChange"
                /> -->
              </div>
              <div
                class="w-100 d-flex flex-column align-items-center justify-content-between"
              >
                <Input
                  :inputValue="user.name"
                  :inputType="'text'"
                  :inputLabel="'Nome'"
                  :inputTypeNotValidation="true"
                  @onUpdate="(value) => validateInputLetters(value)"
                />
                <Input
                  :inputValue="user.email"
                  :inputType="'email'"
                  :inputLabel="'E-mail'"
                  :inputTypeNotValidation="false"
                  :disabled="true"
                  :justView="true"
                />
              </div>
            </div>
          </section>

          <section
            class="card-styling d-flex flex-column justify-content-between align-items-start"
            id="section-security"
          >
            <h6 style="margin-bottom: 32px">Segurança</h6>
            <Input
              :inputValue="user.password"
              :inputType="typeCurrentPassword"
              :inputLabel="'Senha atual'"
              :inputTypeNotValidation="false"
              @onUpdate="(value) => handleInputValue('password', value)"
              @clickVerSenha="clickVerSenha('typeCurrentPassword')"
            />
            <div
              class="w-100 d-flex align-items-center justify-content-between"
              style="height: -webkit-fill-available"
            >
              <div
                class="d-flex flex-column justify-content-between align-items-start w-100 input-new-password-responsive"
              >
                <Input
                  :inputValue="user.newPassword"
                  :inputType="typeNewPassword"
                  :inputLabel="'Nova senha'"
                  :inputTypeNotValidation="false"
                  inputId="input-new-password"
                  :isValid="isOkPassword"
                  @onUpdate="(value) => handleInputValue('newPassword', value)"
                  @clickVerSenha="clickVerSenha('typeNewPassword')"
                  @isValid="isValid()"
                />
                <span v-if="!isOkPassword">
                  <p
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 12px;
                      margin: 5px 0;
                      color: var(--red-medium);
                    "
                  >
                    {{ statusPassword }}
                  </p>
                </span>
              </div>

              <div
                class="d-flex flex-column justify-content-between align-items-start w-100 input-confirm-new-password-responsive"
              >
                <Input
                  :inputValue="confirmNewPassword"
                  :inputType="typeConfirmNewPassword"
                  :inputLabel="'Confirmar nova senha'"
                  :inputTypeNotValidation="false"
                  inputId="input-confirm-new-password"
                  :isValid="isOkConfirmPassword"
                  @onUpdate="
                    (value) => handleInputValue('confirmNewPassword', value)
                  "
                  @clickVerSenha="clickVerSenha('typeConfirmNewPassword')"
                  @isValid="isValid()"
                />
                <span v-if="confirmNewPassword.length > 0">
                  <p
                    v-if="!isPasswordMatch"
                    style="
                      font-style: normal;
                      font-weight: 400;
                      font-size: 12px;
                      margin: 5px 0;
                      color: var(--red-medium);
                    "
                  >
                    As senhas não conferem
                  </p>
                </span>
              </div>
            </div>
          </section>
        </div>

        <div class="card-styling" style="margin: 24px 0">
          <section
            class="d-flex w-100 justify-content-between align-items-center flex-wrap"
          >
            <div style="width: 50%">
              <h6 style="margin-bottom: 32px">Loja Associadas</h6>
            </div>
            <div style="width: 50%">
              <InputSearch @onUpdate="(value) => getStoreByName(value)" />
            </div>
          </section>
          <section
            class="d-flex w-100 justify-content-center align-items-center table-responsive"
          >
            <div class="table-responsive w-100">
              <table class="table align-middle">
                <thead class="thead">
                  <tr style="height: 50px">
                    <th>Nome</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="store in stores" :key="store.id">
                    <td>{{ store.pageName }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
          <Pagination
            :count="totalStores"
            :offset="offset"
            @firstPage="pagination('clickFirstPage')"
            @previousPage="pagination('clickPreviousPage')"
            @nextPage="pagination('clickNextPage')"
            @lastPage="pagination('clickLastPage')"
          />
        </div>

        <footer
          class="card-styling d-flex align-items-center justify-content-end"
        >
          <div class="d-flex align-items-center" style="width: 60%">
            <router-link
              :to="{ name: 'Dashboard' }"
              style="
                border-radius: 8px;
                text-align: center;
                background-color: var(--blue-light);
                color: var(--blue-medium);
                font-style: normal;
                font-weight: 500;
                font-size: 16px;
                height: 56px;
                margin: 8px;
              "
              class="border-0 w-100 d-flex align-items-center justify-content-center text-decoration-none"
            >
              Voltar
            </router-link>
            <button
              type="submit"
              class="border-0 w-100"
              style="background-color: var(--green-medium)"
            >
              Salvar
            </button>
          </div>
        </footer>
      </section>
    </form>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import Input from "@/components/Input.vue";
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Loading from "vue-loading-overlay";

export default {
  name: "Profile",
  components: { Breadcrumb, Input, InputSearch, Pagination, Loading },
  data() {
    return {
      url: "",
      user: {
        name: "",
        email: "",
        image: "",
        password: "",
        newPassword: "",
      },
      confirmNewPassword: "",
      typeCurrentPassword: "",
      typeNewPassword: "",
      typeConfirmNewPassword: "",
      statusPassword: "",
      isOkPassword: false,
      isOkConfirmPassword: false,
      isPasswordMatch: true,
      isLoading: false,
      stores: [],
      totalStores: 0,
      offset: 0,
      nameToSearch: "",
    };
  },
  async created() {
    this.isLoading = true;

    this.typeConfirmNewPassword = "password";
    this.typeNewPassword = "password";
    this.typeCurrentPassword = "password";

    await this.getUser();
    await this.getStoresByPagination({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 5,
    }).then((response) => {
      this.totalStores = response.data.count;
      this.stores = response.data.data;
    });

    this.isLoading = false;
  },
  computed: {
    ...mapGetters(["getOffset"]),
    breadcrumbItems() {
      return [
        { label: "Dashboard", route: { name: "Dashboard" } },
        { label: "Perfil", active: true },
      ];
    },
  },
  methods: {
    ...mapActions(["getUserByEmail", "updateUser", "getStoresByPagination"]),

    ...mapMutations(["SET_OFFSET"]),

    onFileChange(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    clickVerSenha(inputName) {
      if (inputName === "typeCurrentPassword") {
        if (this.typeCurrentPassword === "password") {
          this.typeCurrentPassword = "text";
        } else if (this.typeCurrentPassword === "text") {
          this.typeCurrentPassword = "password";
        }
      }
      if (inputName === "typeNewPassword") {
        if (this.typeNewPassword === "password") {
          this.typeNewPassword = "text";
        } else if (this.typeNewPassword === "text") {
          this.typeNewPassword = "password";
        }
      }
      if (inputName === "typeConfirmNewPassword") {
        if (this.typeConfirmNewPassword === "password") {
          this.typeConfirmNewPassword = "text";
        } else if (this.typeConfirmNewPassword === "text") {
          this.typeConfirmNewPassword = "password";
        }
      }
    },
    handleInputValue(propertyName, propertyValue) {
      if (propertyName == "confirmNewPassword") {
        this.confirmNewPassword = propertyValue;
      } else {
        this.user = Object.assign(
          {},
          this.user,
          this.setObjectProperty(this.user, propertyName, propertyValue)
        );
      }
    },
    isValid() {
      let isValidPassword = document.getElementById("input-new-password").value;
      let isValidConfirmPassword = document.getElementById(
        "input-confirm-new-password"
      ).value;

      //   let btnSubmit = document.querySelector('button[type="submit"]');

      let ucase = new RegExp("[A-Z]+");
      let lcase = new RegExp("[a-z]+");
      let num = new RegExp("[0-9]+");
      let specialcharacter = new RegExp(/\W|_/);

      // condição que verifica se a senha contém os requisitos para nova senha
      if (isValidPassword != "") {
        if (
          !(isValidPassword.length > 0 && isValidPassword.length >= 8) ||
          !ucase.test(isValidPassword) ||
          !lcase.test(isValidPassword) ||
          !num.test(isValidPassword) ||
          !specialcharacter.test(isValidPassword)
        ) {
          this.statusPassword = "Senha não atende aos requisitos de segurança";
          this.isOkPassword = false;
        } else {
          this.statusPassword = "";
          this.isOkPassword = true;
        }
      } else {
        this.statusPassword = "";
        this.isOkPassword = true;
      }

      //condição que verifica a nova senha se condiz com a confirmação da nova senha
      if (!(isValidConfirmPassword === this.user.newPassword)) {
        if (isValidConfirmPassword.length > 0) {
          this.isOkConfirmPassword = false;
          this.isPasswordMatch = false;
        }
        // btnSubmit.disabled = true;
      } else {
        this.isOkConfirmPassword = true;
        this.isPasswordMatch = true;
        // btnSubmit.disabled = false;
      }
      //Desativa o disabled do button type submit(ao estado default)
      if (isValidPassword == "" || isValidConfirmPassword == "") {
        // btnSubmit.disabled = false;
      }
    },
    async editUser() {
      try {
        await this.updateUser(this.user);
        document.location.reload(true);
      } catch (error) {
        switch (error.status) {
          case 400:
            this.isOkResponse = false;
            this.isOkEmail = false;
            this.responseText = "Login e/ou senha inválidos!";
            this.showAlert = true;
            break;
          case 500:
            this.user.email = "";
            this.user.email = "";
            this.responseText = "Falha ao se logar, contate ao Administrator!";
            this.showAlert = true;
            break;
          default:
            break;
        }
      }
    },
    getUser() {
      this.getUserByEmail().then((response) => {
        const data = response.data.data[0];
        this.user.email = data.email;
        this.user.name = data.name;
      });
    },
    validateInputLetters(value) {
      this.user.name = value.replace(
        /[^A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]/g,
        ""
      );
    },
    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },
    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 5,
      };
      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getStoresByPagination(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - 5);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + 5);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getStoresByPagination(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
input[type="file"] {
  display: none;
}

#label-attach-image {
  background-color: #d3e7fb;
  border-radius: 8px;
  color: #2485ea;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  padding: 15px 30px;
  cursor: pointer;
}
h6 {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  color: var(--grey-medium);
}
button {
  border-radius: 8px;
  text-align: center;
  color: var(--white);
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  height: 56px;
  margin: 8px;
}
#section-personal-data {
  margin: 0 12px 0 0;
}
#section-security {
  margin: 0 0 0 12px;
}
.input-new-password-responsive {
  margin: 0 12px 0 0;
}
.input-confirm-new-password-responsive {
  margin: 0 0 0 12px;
}
.table {
  margin: 0;
}
.table td,
.table th {
  vertical-align: middle;
}
.table th {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey-medium);
  text-align: start;
}
thead.thead {
  border-color: var(--blue-light);
}
tbody tr:nth-last-child(even) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}
tbody tr:nth-last-child(odd) {
  border-top: none !important;
  border-bottom-color: var(--blue-light);
}

@media only screen and (max-width: 410px) {
  #label-attach-image {
    font-size: 13px;
    padding: 12px 14px;
  }
}
@media only screen and (max-width: 700px) {
  #section-personal-data > div,
  #section-security > div {
    flex-direction: column;
  }
  .input-confirm-new-password-responsive,
  .input-new-password-responsive {
    margin: 0;
  }
}
@media only screen and (max-width: 768px) {
  .session-one {
    flex-direction: column;
  }
  #section-security {
    margin: 12px 0 0 0;
  }
  #section-personal-data {
    margin: 0 0 12px 0;
  }
}
</style>
